import { axios } from '@/services/axios';

export const updateVg = (data) => axios.put('/VisibilityGroup', data);
